import { Card } from '@cocoonspace/ui/components/card'
import { Skeleton } from '@cocoonspace/ui/components/skeleton'
import { cn } from '@cocoonspace/ui/lib/utils'

import { useListIntegrations } from '~/domains/account/hooks/use-list-integrations.hook'
import { useAuth } from '~/providers/auth-provider'
import { GoogleCalendar } from './providers/google-calendar'
import { OutlookCalendar } from './providers/outlook-calendar'

export const IntegrationsList = ({
	dense = false,
	showDeleteButtons = false,
	className,
}: {
	dense?: boolean
	showDeleteButtons?: boolean
	className?: string
}) => {
	const { isAuth, isLoading: isAuthLoading } = useAuth()
	const { data: userIntegrations, isLoading } = useListIntegrations()

	const hasGoogleCalendar = userIntegrations?.google?.connected
	const hasMicrosoftOutlook = userIntegrations?.outlook?.connected

	if (isAuthLoading || (isAuth && isLoading)) {
		return Array.from({ length: 2 }).map((_, index) => (
			<div
				key={index}
				className='flex items-center justify-center gap-2 border-t px-4 py-4 pr-6'
			>
				<Skeleton className='size-6 rounded-full' />
				<Skeleton className='h-4 w-[140px]' />
				<Skeleton className='ml-auto h-4 w-16' />
				<Skeleton className='size-4 rounded-full' />
			</div>
		))
	}

	return (
		<Card
			variant='outline'
			className={cn(
				'flex flex-col divide-y',
				{ 'gap-2 divide-y-0 border-0': dense },
				className,
			)}
		>
			{!hasMicrosoftOutlook && (
				<GoogleCalendar
					dense={dense}
					showDeleteButtons={showDeleteButtons}
				/>
			)}

			{!hasGoogleCalendar && (
				<OutlookCalendar
					dense={dense}
					showDeleteButtons={showDeleteButtons}
				/>
			)}
		</Card>
	)
}
